import { eSUB } from "./types";
import { FormTitle } from "../../homePage/styles";
import CloseIcon from "@material-ui/icons/Close";
import { CloseButton } from "../../dashboard/styles";
import React, { useEffect } from "react";
import SubmissionPreview from "pages/submissionPreview";
import { Popup } from "components/popup";
import { ESubInfo } from "pages/newPreQualify/components/bondDetails/types";
import dummy from "./dummy.json";

type ViewESUBPopupProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  eSUB: ESubInfo | null;
};

export const ViewESUBPopup = ({ open, setOpen, eSUB }: ViewESUBPopupProps) => {
  if (!eSUB) {
    return null;
  }

  return (
    <Popup
      open={open}
      setOpen={setOpen}
      width="95vw"
      height="95vh"
      innerHeight="calc(100% - 40px)"
      innerPadding="20px"
      margin="0"
      dialogContent={(
        <div style={{ 
          height: "100%", 
          display: "flex", 
          flexDirection: "column" 
        }}>
          <CloseButton onClick={() => setOpen(false)} aria-label="close">
            <CloseIcon />
          </CloseButton>
          <div style={{ 
            flex: 1, 
            overflow: "hidden", 
            marginTop: "20px",
            height: "calc(100% - 60px)",
            display: "flex",
            flexDirection: "column"
          }}>
            <div style={{ 
              height: "100%",
              overflow: "auto"
            }}>
              <SubmissionPreview
                handleNext={() => {}}
                prequalifyData={eSUB}
                checkCcdcIdValue={() => {}}
                checkSubmitStatus={() => {}}
                ccdcData={{}}
                setCcdcData={() => {}}
                insuranceTypeList={[]}
                setPrequalifyData={() => {}}
                handleSavePreQualifyData={() => {}}
                institutionId=""
                currentDashboardUrl=""
                handleShareOnline={() => {}}
                submitCqs={false}
                isViewEsubPopupView={true}
              />
            </div>
          </div>
        </div>
      )}
    />
  );
};
